import React, { useEffect, useState } from "react";
import Joinus from "../../common/Joinus";
import { initialStates, servicesln, gridln, linkedInServiceDetails } from "../home/Constant";
import SocialLnAni from "./SocialLnAni";
import WhatWeDo from "./WhatWeDo";

const SocialLn = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metaln-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-10"
                data-aos="fade-down" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2 ">
                    LinkedIn Ads
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="sms1-sub-heading">
                    LinkedIn Ads is a platform that allows businesses to create
                    and display ads on LinkedIn, a social networking site for
                    professionals with over 700 million users. LinkedIn's
                    advertising platform allows businesses to target specific
                    professionals based on their job title, industry, company
                    size, and more. LinkedIn Ads can help businesses generate
                    high-quality leads, as users are more likely to be
                    interested in business-related products and services. Types
                    of LinkedIn Ads: Sponsored Content, Sponsored InMail, Text
                    Ads, Display Ads.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={linkedInServiceDetails}/>
      <SocialLnAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridln.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                <p className="py-2">{item.para1}</p>
                </div>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (Linkedin)</h1>
          </div>
          <div className="py-5 overflow-hidden">
            <div class="accordion" id="accordionExample"
              data-aos="fade-left" data-aos-delay="300"
            >
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Why should I use LinkedIn ads?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    LinkedIn ads can help businesses increase brand awareness,
                    generate leads, drive website traffic, and recruit top
                    talent.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How do LinkedIn ads work?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    LinkedIn ads work by allowing businesses to create and
                    display ads to LinkedIn's audience, based on targeting
                    options such as job title, industry, company size, and more.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What types of ads can I run on LinkedIn?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ui>
                      <li>
                        <span className="boldspan">Sponsored Content</span> –
                        Appears in users’ feeds like a regular post (single
                        image, video, or carousel)
                      </li>
                      <li>
                        <span className="boldspan">
                          Sponsored Messaging (InMail Ads){" "}
                        </span>
                        – Sent directly to users’ inboxes.
                      </li>
                      <li>
                        <span className="boldspan"> Text Ads</span> – Simple
                        text-based ads that appear in the sidebar.
                      </li>
                      <li>
                        <span className="boldspan"> Dynamic Ads</span> –
                        Personalized ads that use profile data.
                      </li>
                      <li>
                        <span className="boldspan">Lead Gen Ads</span> –
                        Includes built-in forms to capture leads.
                      </li>
                    </ui>
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How do I target the right audience?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <ul>
                      <li>Job title, industry, and company size</li>
                      <li>Skills, education, and seniority level</li>
                      <li>Location and demographics</li>
                      <li>Website visitors (retargeting)</li>
                      <li>Matched audiences (email lists, CRM data, etc.)</li>
                    </ul>
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingFive">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Which businesses should use LinkedIn Ads?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            <span className="boldspan">B2B companies </span>
                            targeting decision-makers and professionals.
                          </li>
                          <li>
                            <span className="boldspan">Recruiters </span>{" "}
                            looking for top talent.
                          </li>
                          <li>
                            {" "}
                            <span className="boldspan">
                              SaaS & Tech companies
                            </span>{" "}
                            promoting business solutions.
                          </li>
                          <li>
                            <span className="boldspan">
                              Financial services, consultants, and corporate
                              training providers.
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How long does it take to see results from LinkedIn Ads?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Results vary based on your budget, audience, and ad
                        quality. Some businesses see engagement within a few
                        days, while lead generation may take{" "}
                        <span className="boldspan">weeks of optimization.</span>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Can I track LinkedIn Ad performance?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>
                            Yes! LinkedIn Campaign Manager provides detailed
                            analytics, including:
                          </li>
                          <li>Click-through rate (CTR)</li>
                          <li>Impressions and engagement</li>
                          <li>Conversion tracking</li>
                          <li>
                            Cost-per-click (CPC) and return on investment (ROI)
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Why are my LinkedIn Ads not performing well?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <ul>
                          <li>Common reasons include:</li>
                          <li>Broad or incorrect audience targeting</li>
                          <li>Weak ad copy or visuals</li>
                          <li>Unclear call-to-action (CTA)</li>
                          <li>Low budget or high competition</li>
                        </ul>
                        <span className="boldspan">Solution:</span> Optimize
                        targeting, test different ad creatives, and adjust your
                        bidding strategy.
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default SocialLn;
